export class App {
    static screens;
    static init(screens) {
        this.screens = screens;
    }
}
